import { render, staticRenderFns } from "./DisclaimerCondizioni.vue?vue&type=template&id=4047b02e&scoped=true"
import script from "./DisclaimerCondizioni.vue?vue&type=script&lang=js"
export * from "./DisclaimerCondizioni.vue?vue&type=script&lang=js"
import style0 from "./DisclaimerCondizioni.vue?vue&type=style&index=0&id=4047b02e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4047b02e",
  null
  
)

export default component.exports